module.exports = __webpack_public_path__ + "4cb2ba6a8075f0fa441b4962c336704d.pdf";